/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import { Profile } from '../components/Profile';
import { ChatPanel } from '../components/ChatPanel';

export interface ViewPanelProps extends React.Props<ViewPanel> {
    className?: string;
    user?: any;
}

export interface ViewPanelState {
    activeProfiles: any;
    inactiveProfiles: any;
    userListener: any;
}

const w = window;

export class ViewPanel extends React.Component<ViewPanelProps, ViewPanelState> {
    constructor(props: ViewPanelProps) {
        super(props);

        this.state = {
            activeProfiles: [],
            inactiveProfiles: [],
            userListener: null
        };

        //w.onfocus = this.onFocus.bind(this);
        //w.onblur = this.onBlur.bind(this);
    }

    public render() {
        let activeProfiles = [];
        let inactiveProfiles = [];
        let timestamp = Date.now();
        for (let uid in this.state.activeProfiles) {
            if (timestamp - this.state.activeProfiles[uid].timestamp < 60*1000) {
                activeProfiles.push(this.state.activeProfiles[uid].node);
            } else {
                inactiveProfiles.push(this.state.inactiveProfiles[uid].node);
            }
        }

        for (let uid in this.state.inactiveProfiles) {
            if (!this.state.activeProfiles[uid]) {
                inactiveProfiles.push(this.state.inactiveProfiles[uid].node);
            }
        }
        return (
            <div className="viewpanel">
                <div className="viewpanel__left">
                    <div className="viewpanel__section">
                        <div className="viewpanel__section_title">
                            Live ({activeProfiles.length} online)
                        </div>
                        <div className="viewpanel__profiles">
                            {activeProfiles}
                        </div>
                    </div>
                    <div className="viewpanel__section">
                        <div className="viewpanel__section_title">
                            Inactive
                        </div>
                        <div className="viewpanel__profiles">
                            {inactiveProfiles}
                        </div>
                    </div>
                </div>
                <div className="viewpanel__right">
                    <ChatPanel user={this.props.user} />
                </div>
            </div>
        );
    }

    private onFocus() {
        let database = w.firebase.database();
        this.setState((prevState) => {
            prevState.userListener = database.ref('users').on('child_changed', (data) => {
                this.updateUser(data.val());
            })
            return prevState;
        });
    }

    private onBlur() {
        let database = w.firebase.database();
        database.ref('users').off();
    }

    private pruneProfiles() {
        this.setState((prevState) => {
            let timestamp = Date.now();
            for (let uid in prevState.activeProfiles) {
                if (timestamp - prevState.activeProfiles > 1000 * 60) {
                    delete prevState.activeProfiles[uid];
                }
            }
            return prevState;
        });
    }

    public componentDidMount() {
        this.loadAllUsers();
        this.onFocus();
    }

    private updateUser(user) {
        this.setState((prevState) => {
            prevState.activeProfiles[user.uid] = {
                node: <Profile user={user} />,
                timestamp: Date.now()
            }
            return prevState;
        });
    }
    //
    private loadAllUsers() {
        let database = w.firebase.database();
        database.ref('users').once('value', (data) => {
            let users = data.val();
            this.setState((prevState) => {
                for (let uid in users) {
                    prevState.inactiveProfiles[uid] = {
                        node: <Profile user={users[uid]} />,
                        timestamp: Date.now()
                    }
                }
                return prevState;
            });
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ViewPanel.tsx
 **/